import { useEffect, useState } from 'react';
import Restricted from '../CommonComponents/Restricted';
import { Cookies } from 'react-cookie-consent';
import PropTypes from 'prop-types'; 
import { getUserId } from '../Services/ApiServices/userServices';

const PrivateRoute = ({ children }) => {
    const [authenticated, setAuthenticated] = useState((Cookies?.get('ar_user_Id') && (Cookies.get('ar_user_Id') !== "" || Cookies.get('ar_user_Id') !== null || Cookies.get('ar_user_Id') !== undefined)) ? true : false);
    
    useEffect(() => {
        if(process.env.REACT_APP_NODE_ENV === "local" && !Cookies?.get('ar_user_Id')) {
            try{
                getUserId(process.env.REACT_APP_USERID,(response) => { 
                    if(response.data.ar_user_Id && response.data.ar_user) {
                        Cookies.set('ar_user', response.data.ar_user)
                        Cookies.set('ar_user_Id', response.data.ar_user_Id)
                        Cookies.set('locale', response.data.locale)
                        setAuthenticated(true);
                    } else {
                        setAuthenticated(false);
                    }
                }, (err) => {
                    console.log(err);
                    setAuthenticated(false);
                });
              }
             catch(err){
                console.log(err);
                setAuthenticated(false);
            }
        }
    }, [])

    return authenticated ? children : <Restricted />;
};

PrivateRoute.propTypes = {
    children: PropTypes.node.isRequired
};

export default PrivateRoute;
